export const CONFIGURATION = {
    name: '[KPI] Well Operations Navigation',
    type: 'kpi-well-operations-navigation',
    description: 'This plugin able to navigation in all well operations.',
    cfg: {
        panels: [],
        displayWellName: false,
        displaySpan: false
    }
}
